import { format } from 'date-fns'

// A vigência de um cenário é um intervalo de dias (o seletor não tem hora). A API guarda cada dia como
// meia-noite UTC; no navegador, o dia que o usuário vê é o dia civil local. Estas funções convertem entre os dois
// sem deixar o fuso (UTC-3) empurrar a data para o dia anterior ou seguinte.

const DIA_CIVIL = /^\d{4}-\d{2}-\d{2}$/

/** Data escolhida no seletor -> `yyyy-MM-dd` pelo dia que o usuário vê (ignora a hora que o seletor mantém). */
export function paraDiaCivil(valor: Date | string): string {
  if (typeof valor === 'string' && DIA_CIVIL.test(valor)) {
    return valor
  }

  return format(new Date(valor), 'yyyy-MM-dd')
}

/** Dia guardado pela API (meia-noite UTC) -> `Date` local à meia-noite do mesmo dia, para exibir e editar. */
export function doDiaCivil(valor: Date | string): Date {
  const data = new Date(valor)

  return new Date(data.getUTCFullYear(), data.getUTCMonth(), data.getUTCDate())
}

/** Dia guardado pela API -> `yyyy-MM-dd` (a parte de data em UTC), para comparar dias como texto. */
export function diaGuardado(valor: Date | string): string {
  return new Date(valor).toISOString().slice(0, 10)
}
